import * as React from 'react';

function SvgCloudHailFill(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M3.75 15.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm.408-3.724a.5.5 0 01.316.632l-.5 1.5a.5.5 0 11-.948-.316l.5-1.5a.5.5 0 01.632-.316zM7.75 15.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm.408-3.724a.5.5 0 01.316.632l-.5 1.5a.5.5 0 11-.948-.316l.5-1.5a.5.5 0 01.632-.316zm3.592 3.724a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm.408-3.724a.5.5 0 01.316.632l-.5 1.5a.5.5 0 11-.948-.316l.5-1.5a.5.5 0 01.632-.316zm1.247-6.999a5.001 5.001 0 00-9.499-1.004A3.5 3.5 0 103.5 10.5H13a3 3 0 00.405-5.973z' />
		</svg>
	);
}

export default SvgCloudHailFill;
